module.exports = __webpack_public_path__ + "static/media/400136_01.66b4b103.png";